import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AcceptInvitePage } from '@/features/auth';

/** Target of the invitation email. No session guard: the page itself handles an existing session. */
export const Route = createFileRoute('/(public)/accept-invite')({
  validateSearch: z.object({ token: z.string().optional() }),
  component: AcceptInviteRoute,
});

function AcceptInviteRoute() {
  const { token } = Route.useSearch();
  return <AcceptInvitePage token={token} />;
}
